// Watching an element's size. A ResizeObserver callback that changes layout (moves the underline, refits the emojis,
// sets --nearby-h) can make the same element resize again in the same frame; browsers then raise "ResizeObserver
// loop completed with undelivered notifications." So every observer here goes through this: the callback runs on the
// next animation frame, many reports in one frame run once, and unmounting cancels a run that hasn't happened yet.

/** Calls `run` on the next animation frame after `el` resizes (once per frame). Returns the stop function. */
export function observeResize(el: Element, run: () => void): () => void {
  let frame = 0;
  const watch = new ResizeObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; run(); });
  });
  watch.observe(el);
  return () => { watch.disconnect(); if (frame) cancelAnimationFrame(frame); frame = 0; };
}
